export enum ChatStatusAction {
	INITIAL_LOADING = "chatbot/INITIAL_LOADING",
	TOGGLE_CHATBOT = "chatbot/TOGGLE_CHATBOT",
	HIDE_CHATBOT = "chatbot/HIDE_CHATBOT",
	START_CHATBOT_LOG_REQUEST = "chatbot/START_CHATBOT_LOG_REQUEST",
	START_CHATBOT_LOG_SUCCESS = "chatbot/START_CHATBOT_LOG_SUCCESS",
	START_CHATBOT_LOG_FAILURE = "chatbot/START_CHATBOT_LOG_FAILURE",

	LOADING_CHATBOT_START = "LOADING_CHATBOT_START",
	LOADING_CHATBOT_END = "LOADING_CHATBOT_END",
}

interface ToggleBotStatusAction {
	type: ChatStatusAction.TOGGLE_CHATBOT,
	status: boolean
}

interface HideChatBot {
	type: ChatStatusAction.HIDE_CHATBOT,
}

interface InitialLoading {
	type: ChatStatusAction.INITIAL_LOADING
}

interface LoadingChatbotEnd {
	type: ChatStatusAction.LOADING_CHATBOT_END
}
export interface IChatStatus {
	status: boolean
	initialLoading: boolean
	hide: boolean
	start: boolean
	loading: boolean
}

export type ChatStatusActionTypes = ToggleBotStatusAction
	| HideChatBot
	| InitialLoading
	| LoadingChatbotEnd